import React from "react";

export default () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 28 28"
      width="36"
      height="36"
    >
      <path d="M0,0V28H28V0ZM26,2V9.24L15.14,17.91l-5.79-3L2,20.34V2ZM2,26V21.58l7.45-5.5,5.81,3L26,10.52V26ZM9.8,12.1A3.8,3.8,0,1,0,6,8.3,3.8,3.8,0,0,0,9.8,12.1Zm0-6.6a2.8,2.8,0,1,1,0,5.6A2.73,2.73,0,0,1,7,8.3,2.93,2.93,0,0,1,9.8,5.5Z"></path>
    </svg>
  );
};
